import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useWorkHourQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    // Get work hours for the business
    const workHourForBusinessQuery = useQuery({
        queryKey: ["work-hour", "business"],
        queryFn: () =>
            axiosPrivate
                .get("work-hour/get_for_business/")
                .then(r => r.data),
    });

    // MUTATIONS ------------------------------------------------------

    // Update work hours for the business
    const updateWorkHourBusinessMutation = useMutation({
        mutationFn: (data) =>
            axiosPrivate
                .patch("work-hour/update_business/", data)
                .then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["work-hour"]);
        },
    });

    return {
        // queries
        workHourForBusinessQuery,

        // mutations
        updateWorkHourBusinessMutation,
    };
}
